/**
 * M2-4: Cinematic Progress Bar — 工具栏上方的胶囊进度条。
 * 与 Pill 组件风格对齐。
 */
import { useViewerStore } from '@stores/viewerStore';

interface CinematicProgressBarProps {
  /** Called when user seeks to a new time (seconds). */
  onSeek: (t: number) => void;
  /** Total track duration in seconds. */
  duration: number;
}

export function CinematicProgressBar({ onSeek, duration }: CinematicProgressBarProps) {
  const currentTime = useViewerStore((s) => s.cinematicCurrentTime);
  const cinematicState = useViewerStore((s) => s.cinematicState);

  const progress = duration > 0 ? Math.min(currentTime / duration, 1) : 0;

  if (cinematicState === 'idle') return null;

  return (
    /* 非播放时渐隐 */
    <div
      className={[
        'pointer-events-auto relative h-6 w-full max-w-[500px] rounded-[32px]',
        'bg-[var(--surface)]',
        'shadow-[0px_14px_28px_rgba(0,0,0,0.08),0px_-6px_12px_rgba(0,0,0,0.03),0px_2px_8px_rgba(0,0,0,0.06)]',
        'opacity-100 transition-opacity duration-500',
      ].join(' ')}
    >
      {/* 隐藏的原生 range input 覆盖整个容器负责拖拽交互 */}
      <input
        type="range"
        aria-label="Cinematic progress"
        min={0}
        max={duration}
        step={0.01}
        value={currentTime}
        className="absolute inset-0 z-10 h-full w-full cursor-pointer opacity-0"
        onChange={(event) => onSeek(Number(event.currentTarget.value))}
      />
      <div className="absolute inset-x-[18px] top-1/2 h-1.5 -translate-y-1/2">
        {/* 轨道背景 */}
        <div className="absolute inset-0 rounded-full bg-[color-mix(in_oklch,var(--surface-secondary-foreground)_20%,transparent)]" />
        {/* 已播放部分 */}
        <div
          className="absolute inset-y-0 left-0 rounded-full bg-[color-mix(in_oklch,var(--surface-secondary-foreground)_60%,transparent)] transition-none"
          style={{ width: `${progress * 100}%` }}
        />
      </div>
    </div>
  );
}
